<template>
  <div
    v-if="isExternal"
    :style="styleExternalIcon"
    v-bind="$attrs"
    class="svg-external-icon svg-icon"
  />
  <svg
    v-else
    :class="svgClass"
    v-bind="$attrs"
    aria-hidden="true"
  >
    <use :href="iconName" />
  </svg>
</template>

<script>
// doc: https://panjiachen.github.io/vue-element-admin-site/feature/component/svg-icon.html#usage

export default {
  __name: 'Icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    class: {
      type: String,
      default: ''
    }
  },
  computed: {
    isExternal() {
      return this._IsExternal(this.icon)
    },
    iconName() {
      return `#icon-${this.icon}`
    },
    svgClass() {
      if (this.class) {
        return 'svg-icon ' + this.class
      } else {
        return 'svg-icon'
      }
    },
    styleExternalIcon() {
      return {
        mask: `url(${this.icon}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.icon}) no-repeat 50% 50%`
      }
    }
  },
  methods: {
    _IsExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    }
  }
}
</script>

<style>
.svg-icon {
  width: 12px;
  height: 12px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover!important;
  display: inline-block;
}
</style>
